import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BackendService } from '../backend.service';
import { SessionStorageService } from 'ngx-webstorage';
import { Application, States, MerchantData, MambuLoan, AcquisitionChannelData, RecommendedAndOtherEMIPlans, MerchantConfig, GiftCardVouchers, ActiveApplication, EmiOption, GCToken } from './application';
import { TokenService } from '../token/token.service';
import { Observable, forkJoin } from 'rxjs';
import { LoginService } from '../login/login.service';
import { CounterOffer } from '../risk/risk';
import { CashCreditPricing, PersonalLoanPricingCap, PersonalLoanPricingEmiOptions } from '../cash-credit/cash-credit/cash-credit';
import { environment } from '../../environments/environment';
import { mobileCheck } from 'app/common/tracking/aws-tracker';

@Injectable()
export class ApplicationService {

  private orderDetailsUrl = '/ApplicationFlow/LoanApplications/{applicationId}';
  private getRecommendedAndOtherEMIPlansUrl = '/Pricing/V2/Quote/AvailableEmiPlans?merchantId={merchantId}&basketAmount={basketAmount}';
  private setEMIUrl = '/ApplicationFlow/LoanApplications/{applicationId}/EmiPlans';
  private assignApplicationUrl = '/ApplicationFlow/LoanApplications/{applicationId}/Customer/{customerId}';
  private getActiveApplicationsUrl = '/ApplicationFlow/LoanApplications/active';
  private changeApplicationStatusURL = '/ApplicationFlow/LoanApplications/{applicationId}/statuses/current';
  private changeApplicationStatusZestURL = '/zestlife-channel/api/v1/redemption/refund';
  private getStateUrl = '/ApplicationFlow/LoanApplications/{applicationId}/States';
  private postStateUrl = '/ApplicationFlow/LoanApplications/{applicationId}/States/{state}';
  private getVoucherMerchantsUrl = '/application_flow/api/v1/MerchantSettings/VoucherMerchants';
  private getMerchantDataUrl = '/application_flow/merchantcustomer/unsecured/api/v1/application/{applicationId}';
  private getMerchantRouteUrl = '/routesV2/{merchantname}.json';
  private getMerchantNameUrl = '/application_flow/unsecured/merchant/api/v1/MerchantSettings/{merchantId}';
  private getMerchantTermUrl = '/merchants.json';
  private mambuLoanUrl = '/ZestMambu/Loans/{LoanId}/Association';
  private concurrentLoanApplicationUrl = '/Loan/Customers/{customerId}/ActiveLoanStatus';
  private postCustomerStateUrl = '/preapprove/customer/{customerId}/states/{state}';
  private customerApplicationStatesUrl = '/preapprove/api/v2/customer/{customerId}?applicationId={applicationId}';
  private setAffiliateMarketingCampaignUrl = '/preapprove/customer/{customerId}/{affiliate}/affiliate';
  private createApplicationUrl = '/ApplicationFlow/LoanApplications/{applicationId}/LoanAccount';
  private applicationChannelUrl = '/application_flow/user/acquisition/channel/';
  private counterOfferUrl = '/ApplicationFlow/LoanApplications/{applicationId}/CounterOffer';
  private approveCounterOfferUrl = '/ApplicationFlow/LoanApplications/{applicationId}/States/TenureChange/Approval?decision={decision}';
  private approveLoanAmountChangeCounterOfferUrl = '/ApplicationFlow/LoanApplications/{applicationId}/CustomerDecision?decision={decision}';
  private patchLoanAmountToApplicationUrl = '/ApplicationFlow/LoanApplications/{applicationId}/Update';
  private checkMerchantConfigUrl = '/preapprove/merchantflow/?merchantId={merchantId}&encrypt={encryption}&customerId={customerId}';
  private getGiftCardVoucherDetailsUrl = '/wallet/api/v1/application/{applicationId}/voucher';
  private createGiftCardVoucherUrl = '/wallet/api/v1/application/voucher';
  private createGiftCardVoucherV2Url = '/wallet/api/v2/application/voucher';
  private getTokenForVoucherUrl = '/wallet/api/v1/vouchers/token';
  private personalLoanPricingUrl = '/Pricing/V2/PersonalLoan/EmiPlans/{customerId}';
  private createPersonalLoanApplicationUrl = '/ApplicationFlow/V2/LoanApplications/PersonalLoan';
  private fundWalletUrl = '/wallet/api/v1/loanApplication';
  private featureSwitchUrl = '/features/{featureId}?merchantId={merchantId}';
  private featureTagUrl = '/features/{featureId}/tag';
  private bannerConfigUrl = '/config-assets/new-merchant-list.json';
  private personalLoanMerchantPricingUrl = '/Pricing/V2/Quote/EmiPlans?merchantId={merchantId}&basketAmount={basketAmount}';
  private getFlowDetailsUrl = '/zestlifeweb/v1/pdms-config/merchant/{merchantId}';
  private cjmInitiateV1 = '/customer-journey-manager/v1/customers/{customerId}/initiate';
  private cjmInitiateV2 = '/customer-journey-manager/v2/customers/{customerId}/initiate' ;
  private cjmJourneyUrl = environment.isUnifiedFlow ? this.cjmInitiateV2 : this.cjmInitiateV1;
  private nextModuleUrl = '/customer-journey-manager/v1/customers/{customerId}/journeys/{journeyId}/next';
  private getMerchantThemeUrl = '/themes/{merchantName}.json';
  private reactivationSwitchURL = '/switch/cl_reactivation.json';
  private homescreenUrl = '/zestlife/v1/Customers/{customerId}/Journeys/{journeyId}/Dashboard';
  private createCJMApplicationUrl = '/application_flow/Api/V2/LoanApplication/Create';
  private assignCJMApplicationUrl = '/application_flow/Api/V2/LoanApplication/Application/{ApplicationId}/Customer/{customerId}';
  private personalLoanPricingCapUrl = '/pricing-engine/customers/{customerId}';
  private personalLoanPricingEmiOptionsUrl = '/pricing-engine/customers/{customerId}/personal-loan-emi-options?basketAmount={{basketAmount}}&type={{plType}}';
  private createVoucherDenominationurl = '/zestlife-channel/api/v1/redemption/denomination';
  private loggerUrl = '/zestlifeweb/v1/log';
  private whatsappConsentUrl = '/growth/whatsapp/consent';
  private getAPRContentUrl = '/apr-details.json';
  private getAPRSwitchURL = '/apr-flags.json';

  constructor(private sessionStorage: SessionStorageService, private loginService: LoginService, private router: Router, private backendService: BackendService, private tokenService: TokenService) { }

  getApplicationId() {
    return this.sessionStorage.retrieve('zest-application') ? this.sessionStorage.retrieve('zest-application').ApplicationId as string : null;
  }
  getMerchantId() {
    return this.sessionStorage.retrieve('zest-application') ? this.sessionStorage.retrieve('zest-application').MerchantId as string : null;
  }
  getDpConfig() {
    return this.sessionStorage.retrieve('zest-application') ? this.sessionStorage.retrieve('zest-application').IsDpAfterRiskApproval as boolean : false;
  }
  getApplication(): Application {
    return this.sessionStorage.retrieve('zest-application') ? this.sessionStorage.retrieve('zest-application') as Application : null;
  }
  getActiveApplications(): Observable<ActiveApplication[]> {
    return this.backendService.getData(this.getActiveApplicationsUrl, null, false, false);
  }
  getMerchantName(merchantId): Observable<string> {
    return this.backendService.getData(this.getMerchantNameUrl.replace('{merchantId}', merchantId), 'text', false, false);
  }
  getRecommendedAndOtherEMIPlans(merchantId: string, basketAmount: number, merchantUrlDownPayment: number, paymentGatewayId?: string): Observable<RecommendedAndOtherEMIPlans> {
    let url = this.getRecommendedAndOtherEMIPlansUrl.replace('{merchantId}', merchantId).replace('{basketAmount}', basketAmount.toString());
    if (merchantUrlDownPayment && !isNaN(merchantUrlDownPayment)) {
      url += '&downpaymentAmount={downpaymentAmount}';
      url = url.replace('{downpaymentAmount}', merchantUrlDownPayment.toString());
    }
    if (paymentGatewayId && paymentGatewayId.length > 0) {
      url = `${url}&PaymentGatewayId=${paymentGatewayId}`;
    }
    return this.backendService.getData(url, null, false, false, false);
  }
  sortEmiOptionsByNumberOfMonths(a: EmiOption, b: EmiOption) {
    if (a && b) {
      if (a.NumberOfMonths < b.NumberOfMonths) {
        return -1;
      }
      if (a.NumberOfMonths > b.NumberOfMonths) {
        return 1;
      }
    }
    return 0;
  }
  getOrderDetails(applicationId: string): Observable<Application> {
    return this.backendService.getData(this.orderDetailsUrl.replace('{applicationId}', applicationId), null, false, false);
  }
  saveApplication(application: Application) {
    this.sessionStorage.store('zest-application', application);
  }
  removeSavedApplication() {
    this.sessionStorage.clear('zest-application');
  }
  getPreapproveStates(): States | null {
    return this.sessionStorage.retrieve('zest-preapprove-states') ? this.sessionStorage.retrieve('zest-preapprove-states') as States : null;
  }
  savePreapproveStates(states: States) {
    this.sessionStorage.store('zest-preapprove-states', states);
  }
  saveSelectedEmi(applicationId: string, NumberOfMonths: number, downpaymentAmount: number) {
    const postData = { 'NumberOfMonths': NumberOfMonths, 'DownpaymentAmount': downpaymentAmount };
    return this.backendService.setData(this.setEMIUrl.replace('{applicationId}', applicationId), postData);
  }
  assignApplication(): Observable<any> {
    return this.backendService.setData(this.assignApplicationUrl.replace('{applicationId}', this.getApplicationId()), null);
  }
  assignApplicationId(applicationId) {
    return this.backendService.setData(this.assignApplicationUrl.replace('{applicationId}', applicationId), null);
  }
  setAffiliateMarketingCampaign(affiliate: string): Observable<any> {
    return this.backendService.setData(this.setAffiliateMarketingCampaignUrl.replace('{affiliate}', affiliate), null, null, false, false, true);
  }
  changeApplicationStatus(status: string, applicationId: string, cancellationReason: string = null, otherReason: string = null, otpId: string = null) {
    const applicationStatusData = {
      Status: status,
      CancellationReason: cancellationReason,
      OtherReason: otherReason,
      OtpId: otpId
    };
    return this.backendService.setData(this.changeApplicationStatusURL.replace('{applicationId}', applicationId), applicationStatusData);
  }

  changeApplicationStatusZestLife(applicationId: string, partnerId: string) {
    const applicationStatusData = {
      applicationId: applicationId,
      partnerId: partnerId,
    };
    return this.backendService.setData(this.changeApplicationStatusZestURL, applicationStatusData);
  }

  postState(value: string, state: string) {
    if (this.getApplicationId()) {
      return this.backendService.setData(this.postStateUrl.replace('{applicationId}', this.getApplicationId()).replace('{state}', state), { value: value });
    } else {
      return this.backendService.setData(this.postCustomerStateUrl.replace('{state}', state), { state: value });
    }
  }
  postCustomerState(value: string, state: string) {
    return this.backendService.setData(this.postCustomerStateUrl.replace('{state}', state), { state: value });
  }
  postMerchantState(customerId: string, value: string, state: string) {
    return this.backendService.setData(this.postCustomerStateUrl.replace('{state}', state).replace('{customerId}', customerId), { state: value });
  }
  getState(applicationId: string, nextRoute: string = '/') {
    let url = this.customerApplicationStatesUrl;
    if (applicationId) {
      url = this.customerApplicationStatesUrl.replace('{applicationId}', applicationId);
    } else {
      url = this.customerApplicationStatesUrl.replace('{applicationId}', '');
      const merchantKey = this.tokenService.getReferMerchantKey();
      if (merchantKey) {
        url = url + '&merchantKey=' + merchantKey;
      }
    }
    if (nextRoute && nextRoute.length > 0) {
      url = url + '&nextRoute=' + nextRoute;
    }
    const currentRoute = this.router.url;
    url = url + '&currentRoute=' + currentRoute;
    return this.backendService.getData(url).pipe(map(response => {
      const states = response as States;
      if (states && states.customer.creditLimitActive && states.customer.creditLimitExpiryDate && (new Date() > new Date(states.customer.creditLimitExpiryDate))) {
        states.customer.creditLimitActive = false;
      }
      try {
        const application: Application = this.getApplication();
        if (application && states && states.loan && states.loan.CurrentStatus) {
          application.Status = states.loan.CurrentStatus;
          application.IsDPMade = states.loan.IsDownpaymentComplete;
          this.saveApplication(application);
        }
        this.savePreapproveStates(states);
      } catch (err) {
        // Something went wrong..
      }
      return states;
    }));
  }
  getStatesForMerchant(customerId: string): Observable<States> {
    const url = this.customerApplicationStatesUrl.replace('{customerId}', customerId).replace('{applicationId}', '');
    return this.backendService.getData(url);
  }
  getVoucherMerchants(): Observable<ActiveApplication[]> {
    return this.backendService.getData(this.getVoucherMerchantsUrl);
  }
  getMerchantData(applicationId: string): Observable<MerchantData> {
    return this.backendService.getData(this.getMerchantDataUrl.replace('{applicationId}', applicationId));
  }
  getMerchantRoutes(merchantname = 'default', xpeCustomer = false) {
    const states = this.getPreapproveStates();
    const application = this.getApplication();
    const plApplication = application ? (application.Flow === 2 ? true : false) : false;
    const isOfflineGcAgent = this.tokenService.getOfflineGcAgent();
    let jsonName = merchantname;
    if (!isOfflineGcAgent && (application && application.IsVoucherMerchant)) {
      jsonName = jsonName + '-ocd';
    }
    if (xpeCustomer) {
      jsonName = jsonName + '-xpe';
    } else if (states && states.customer.customerType === 'Superprime' && merchantname.includes('pre-enrol')) {
      jsonName = jsonName + '-v2';
    }
    if (plApplication) {
      jsonName = jsonName + '-pl';
    }
    return this.backendService.getData(this.getMerchantRouteUrl.replace('{merchantname}', jsonName), null, false, true, true);
  }
  setRouteConfigs(data) {
    this.checkForGC(data);
    this.sessionStorage.store('zest-route', data);
  }

  checkForGC(data) {
    const application = this.getApplication();
    if (application && (application.Flow === 1) && application.IsVoucherMerchant) {
      const happyFlow = data['settings']['happyFlow'];
      const routes = data['settings']['routes'];
      for (let i = 0; i < routes.length; i++) {
        if (routes[i].paths.indexOf('/risk/postaccept') > -1) {
          routes.splice(i, 1);
          break;
        }
      }
      const index = happyFlow.indexOf('/risk/postaccept');
      if (index > -1) {
        happyFlow.splice(index, 1);
      }
    }
  }

  updateRouteForKyc(updatedRoutes) {
    const oldRoute = this.sessionStorage.retrieve('zest-route');
    if (oldRoute) {
      oldRoute['settings']['routes'] = updatedRoutes;
      this.sessionStorage.store('zest-route', oldRoute);
    }
    return;
  }
  updateRouteForVedantu(updatedRoutes) {
    const oldRoute = this.sessionStorage.retrieve('zest-route');
    if (oldRoute) {
      oldRoute['settings']['routes'] = updatedRoutes;
      this.sessionStorage.store('zest-route', oldRoute);
    }
    return;
  }
  getRouteConfig() {
    return this.sessionStorage.retrieve('zest-route') ? this.sessionStorage.retrieve('zest-route')['settings']['routes'] : null;
  }
  getStepsConfig() {
    return this.sessionStorage.retrieve('zest-route') ? this.sessionStorage.retrieve('zest-route')['settings']['steps'] : null;
  }
  getStepNo(step: string) {
    return (this.sessionStorage.retrieve('zest-route')['settings']['steps'].indexOf(step));
  }
  getNextStep(currentRoute: string): string {
    currentRoute = currentRoute.split('?')[0];
    const routes = this.sessionStorage.retrieve('zest-route')['settings']['happyFlow'];
    return routes.find((route, index, array) => {
      return (array[index - 1] === currentRoute);
    });
  }
  goToNextRoute(currentRoute: string, homescreenRedirection = false) {
    const cjmEnabled = this.tokenService.getCJMFlag();
    const csProduct = this.tokenService.getCrossSellProduct();
    if (homescreenRedirection) {
      window.location.href = window.location.origin + '/journey/homescreen';
    } else if (cjmEnabled && !csProduct) {
      window.location.href = window.location.origin + '/journey/';
    } else {
      const nextroute = this.getNextStep(currentRoute);
      if (nextroute === 'login') {
        this.loginService.goToLoginUrl(false);
      } else {
        this.router.navigate([nextroute]);
      }
    }
  }
  public getMambuLoan(loanId: string): Observable<MambuLoan> {
    return this.backendService.getData(this.mambuLoanUrl.replace('{LoanId}', loanId), null, false);
  }
  public getMerchantTerms() {
    return this.backendService.getData(this.getMerchantTermUrl, null, false, true, true);
  }
  public createApplication(applicationId: string) {
    return this.backendService.setData(this.createApplicationUrl.replace('{applicationId}', applicationId));
  }
  checkWhetherConcurrentLoanApplication() {
    return this.backendService.getData(this.concurrentLoanApplicationUrl);
  }
  getPrevStep(currentRoute: string): string[] {
    currentRoute = currentRoute.split('?')[0];
    const routes = this.sessionStorage.retrieve('zest-route')['settings']['happyFlow'];
    return routes.filter((route, index, array) => {
      return (array[index + 1] === currentRoute);
    });
  }
  goToPrevRoute(currentRoute: string) {
    const nextroute = this.getPrevStep(currentRoute);
    if (nextroute[0] === 'login') {
      this.loginService.goToLoginUrl(false);
    } else {
      this.router.navigate(nextroute);
    }
  }
sendDataToLogger(message: any, additionalData = {}, type = 'ERROR' ) {
    try {
      const application = this.getApplication();
      const merchantId = application ? application.MerchantId : 'NA';
      const merchantName = application ? application.MerchantName : 'NA';
      const applicationId = application ? application.ApplicationId : 'NA';
      const customerId = this.tokenService.getCustomerId() || 'NA';
      const messageAsString = JSON.stringify(message);
      const data = {
          message: messageAsString,
          type,
          category: 'payment-app-fe',
          currentUrl: window.location.pathname,
          platform: mobileCheck() ? 'mWeb' : 'Web',
          applicationId,
          customerId,
          additionalInfo: {
            merchantId,
            merchantName,
            ...additionalData
      } };
        return this.backendService.postCallForLogger(this.loggerUrl, data);
    } catch (error) {
       console.error(error);
    }
}
  saveConcurrency(data) {
    this.sessionStorage.store('zest-concurrency', data);
  }
  getConcurrency() {
    return this.sessionStorage.retrieve('zest-concurrency');
  }
  getApplicationState(applicationId: string): Observable<States> {
    return this.backendService.getData(this.getStateUrl.replace('{applicationId}', applicationId));
  }
  setApplicationChannel(acquisitionChannelData: AcquisitionChannelData) {
    return this.backendService.setData(this.applicationChannelUrl, acquisitionChannelData, null, false, false, true);
  }
  saveCreditLimitCust(status: boolean, creditLimit: any) {
    this.sessionStorage.store('zest-cl-customer', { 'status': status, 'creditLimit': creditLimit });
  }
  getCreditLimitCust() {
    return this.sessionStorage.retrieve('zest-cl-customer');
  }
  getCounterOffer(applicationId: string): Observable<CounterOffer> {
    return this.backendService.getData(this.counterOfferUrl.replace('{applicationId}', applicationId));
  }
  approveCounterOffer(applicationId: string, decision: boolean) {
    return this.backendService.setData(this.approveCounterOfferUrl.replace('{applicationId}', applicationId).replace('{decision}', decision.toString()));
  }
  approveLoanAmountChangeCounterOffer(applicationId: string, decision: boolean) {
    return this.backendService.setData(this.approveLoanAmountChangeCounterOfferUrl.replace('{applicationId}', applicationId).replace('{decision}', decision.toString()));
  }
  patchLoanAmountToApplication(applicationId: string, postParams: any) {
    return this.backendService.patchData(this.patchLoanAmountToApplicationUrl.replace('{applicationId}', applicationId), postParams);
  }
  getMerchantConfigForUI(merchantId: string, encryption: string): Observable<MerchantConfig> {
    const checkoutParams = this.tokenService.getCheckoutParams();
    if (checkoutParams) {
      if (checkoutParams.merchantID) {
        merchantId = checkoutParams.merchantID;
      } else if (checkoutParams.partnerId) {
        merchantId = checkoutParams.partnerId;
      }
    }
    return this.backendService.getData(this.checkMerchantConfigUrl.replace('{merchantId}', merchantId).replace('{encryption}', encryption));
  }
  getGiftCardVoucherDetails(applicationId: string): Observable<GiftCardVouchers> {
    return this.backendService.getData(this.getGiftCardVoucherDetailsUrl.replace('{applicationId}', applicationId));
  }
  getTokenForCreateVoucher(applicationId: string, merchantId: string, merchantName: string): Observable<GCToken> {
    const createGiftCardVoucherData = {
      applicationId,
      merchantId,
      merchantName
    };
    return this.backendService.setData(this.getTokenForVoucherUrl, createGiftCardVoucherData);
  }
  createGiftCardVoucher(applicationId: string, merchantId: string, merchantName: string, useV2Url = false): Observable<GiftCardVouchers> {
    const createGiftCardVoucherData = {
      applicationId,
      merchantId,
      merchantName,
    };
    return this.backendService.setData(useV2Url ? this.createGiftCardVoucherV2Url : this.createGiftCardVoucherUrl, createGiftCardVoucherData);
  }
  copyText(textStr: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = textStr;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }
  getPersonalLoanPricing(): Observable<CashCreditPricing[]> {
    return this.backendService.getData(this.personalLoanPricingUrl);
  }
  createPersonalLoanApplication(amount: number, numberOfInstallments: number, phone: string, email: string, merchantId: string, plType: string): Observable<any> {
    const createPersonalLoanApplicationData = {
      CustomerId: this.tokenService.getCustomerId(),
      Amount: amount,
      NumberOfInstallments: numberOfInstallments,
      MobileNumber: phone,
      Email: email,
      MerchantId: merchantId,
      PersonalLoanType: plType
    };
    return this.backendService.setData(this.createPersonalLoanApplicationUrl, createPersonalLoanApplicationData);
  }
  createGcApplication(data) {
    return this.backendService.setData(this.fundWalletUrl, data);
  }

  getMerchantThemeVariables(merchantName = ''): Observable<any> {
    return this.backendService.getData(this.getMerchantThemeUrl.replace('{merchantName}', merchantName), null, false, true, true);
  }

  getFeatureVersion(featureId: string, useDefault: boolean = false, merchantId: string = environment.dummyUuid): Observable<any> {
    const application = this.getApplication();

    let url = this.featureSwitchUrl.replace('{featureId}', featureId);

    if (application && !useDefault) {
      merchantId = application.GenericMerchantId;
    }
    url = url.replace('{merchantId}', merchantId);
    const customerId = this.tokenService.getCustomerId();
    if (customerId) {
      url = `${url}&customerId=${customerId}`;
    }
    return this.backendService.getCallForAPIGateway(url);
  }

  getMultipleFeaturesVersion(features: Array<string>) {
    const allFeatures = [];
    features.forEach(element => {
      allFeatures.push(this.getFeatureVersion(element));
    });
    return forkJoin(...allFeatures);
  }

  tagFeatureToCustomer(featureId: string, version: string) {
    const url = this.featureTagUrl.replace('{featureId}', featureId);
    const application = this.getApplication();
    const merchantId = application ? application.GenericMerchantId : environment.dummyUuid;
    const customerId = this.tokenService.getCustomerId();
    const data = { customerId, merchantId, featureId, version };
    return this.backendService.postCallForAPIGateway(url, data);
  }

  tagMultipleFeaturesToCustomer(features: Array<any>) {
    const allFeatureTags = [];
    features.forEach(element => {
      allFeatureTags.push(this.tagFeatureToCustomer(element.featureId, element.version));
    });
    return forkJoin(...allFeatureTags);
  }

  getFeatureVersionV2(featureId: string, useDefault: boolean = false, merchantId: string = environment.dummyUuid, idType: string = 'customer-id', id: string = ''): Observable<any> {
    const application = this.getApplication();

    let url = this.featureSwitchUrl.replace('{featureId}', featureId);

    if (application && !useDefault) {
      merchantId = application.GenericMerchantId;
    }
    url = url.replace('{merchantId}', merchantId);
    if (idType === 'customer-id') {
      const customerId = this.tokenService.getCustomerId();
      if (customerId) {
        url = `${url}&id=${customerId}&idType=customer-id`;
      }
    }
    return this.backendService.getCallForAPIGateway(url);
  }

  tagFeatureToCustomerV2(featureId: string, version: string, useDefault: boolean = false, merchantId: string = environment.dummyUuid, idType: string = 'customer-id', id: string = '') {
    const url = this.featureTagUrl.replace('{featureId}', featureId);
    const application = this.getApplication();
    if (application && !useDefault) {
      merchantId = application.GenericMerchantId;
    }
    if (idType === 'customer-id') {
      id = this.tokenService.getCustomerId();
    }
    const data = { featureId, version, merchantId, id, idType };
    return this.backendService.postCallForAPIGateway(url, data);
  }

  getMerchantBannerConfig() {
    return this.backendService.getData(this.bannerConfigUrl, null, false, true, true);
  }

  setPoCLShown(shown) {
    this.sessionStorage.store('zest-pocl-shown', shown);
  }

  getPoCLShown(): boolean {
    const poCLShown = this.sessionStorage.retrieve('zest-pocl-shown');
    return poCLShown ? poCLShown : false;
  }

  getCustomer() {
    const customer = this.sessionStorage.retrieve('zest-cutomer');
    return customer ? customer : null;
  }

  setNewTexts(shown) {
    this.sessionStorage.store('zest-new-texts', shown);
  }

  getNewTexts(): boolean {
    const newTexts = this.sessionStorage.retrieve('zest-new-texts');
    return newTexts ? newTexts : false;
  }

 getFlowType(merchantId: string) {
    const url = this.getFlowDetailsUrl.replace('{merchantId}', merchantId);
    return this.backendService.getData(url);
  }

  createAndGetCJMJourney(merchantId, applicationId = environment.dummyUuid, clIncrease = false) {
    const perfiosLink = this.tokenService.getPerfiosLinkFlag();
    const videoKycLink = this.tokenService.getVideoKycLinkFlag();
    const clIncreaseLink = this.tokenService.getClIncreaseLinkFlag();
    const checkoutParams = this.tokenService.getCheckoutParams();
    const transactionID = checkoutParams ? checkoutParams.transactionId : null;
    const customHeaders = {};
    const channelId = environment.isUnifiedFlow ? {channelId: environment.unifiedChannelId} : {};

    if (clIncrease || clIncreaseLink) {
      customHeaders['tenant-id'] = environment.clIncreaseTenantId;
    }
    const postData = {
      journeyType: 'CreditLimit',
      journeyContext: {
        merchantId: merchantId,
        applicationId: applicationId,
        ...channelId,
        transactionId : transactionID ? transactionID : null
      }
    };
    return this.backendService.putData(this.cjmJourneyUrl, postData, perfiosLink, true, videoKycLink, customHeaders);
  }

  getNextModule(journeyId) {
    return this.backendService.getData(this.nextModuleUrl.replace('{journeyId}', journeyId));
  }

  getHomeScreenModule(merchantId: string, journeyId: string) {
    const url = this.homescreenUrl.replace('{journeyId}', journeyId) + '?merchantId=' + merchantId;
    return this.backendService.getData(url);
  }

  getMerchantPersonalLoanPricing(merchantId: string, basketAmount: number): Observable<CashCreditPricing> {
    const url = this.personalLoanMerchantPricingUrl.replace('{merchantId}', merchantId).replace('{basketAmount}', basketAmount.toString());
    return this.backendService.getData(url, null, false, false, false);
  }
  getCLReactivationSwitch(): Observable<any> {
    return this.backendService.getData(this.reactivationSwitchURL, null, false, false, true);
  }
  createCJMApplication(applicationData: any) {
    return this.backendService.setData(this.createCJMApplicationUrl, applicationData);
  }
  assignCJMApplication(applicationId: string) {
    const url = this.assignCJMApplicationUrl.replace('{ApplicationId}', applicationId);
    return this.backendService.setData(url);
  }

  getPersonalLoanCapPricing(): Observable<PersonalLoanPricingCap> {
    return this.backendService.getData(this.personalLoanPricingCapUrl);
  }
  getPersonalLoanEmiOptionsPricing(basketAmount, plType): Observable<PersonalLoanPricingEmiOptions> {
    return this.backendService.getData(this.personalLoanPricingEmiOptionsUrl.replace('{{basketAmount}}', basketAmount).replace('{{plType}}', plType));
  }

  getDecryptedToken(encryptedToken: string) {
    return this.backendService.postCallForAPIGateway('/sphinx/decrypt-token', { encryptedToken }, 'loanRestructureBaseUrl', 'utsApiKey');
  }

  createVoucherDenomination(applicationId: string) {
    const data = { applicationId };
    return this.backendService.setData(this.createVoucherDenominationurl, data);
  }

  takeWhatsappConsent(): Observable<any> {
    const phoneNumber = '91' + this.tokenService.getCustomerContact();
    const data = {
      customerId: this.tokenService.getCustomerId(),
      number: phoneNumber,
      waNumber: phoneNumber,
      optedOut: false
    };
    return this.backendService.setData(this.whatsappConsentUrl, data);
  }
  getAPRContent() {
    return this.backendService.getData(this.getAPRContentUrl, null, false, true, true);
  }
  getAPRSwitch() {
    return this.backendService.getData(this.getAPRSwitchURL, null, false, true, true);
  }
}
